<div class="language-schools" *ngIf="courseDetails$ | async as courseDetails">
  <lx-single-selection-button-list-field
    title="Language"
    i18n-title
    [options]="languages$ | async"
    [ngModel]="courseDetails.selectedLanguage"
    (ngModelChange)="updateSelectedLanguage($event)"
    bindValue="code"
    data-qa="languageSchools_languageField"
  ></lx-single-selection-button-list-field>
  <lx-location-selector-field
    [groupedSchoolLocations]="groupedSchoolLocations$ | async"
    [selectedValue]="courseDetails.selectedSchoolLocation"
    (selectedValueChange)="updateSelectedSchoolLocation($event)"
  />
  <lx-adult-courses
    [courseDetails]="courseDetails"
    [automaticOpenDatePanel$]="automaticOpenDatePanel$"
    (selectedCourseChange)="updateSelectedCourse($event)"
    (selectedDurationChange)="updateSelectedDuration($event)"
    (selectedStartDateChange)="updateSelectedStartDate($event)"
  ></lx-adult-courses>
</div>
